import {Dispatch, ReactNode, SetStateAction, useState} from 'react';
import {BaseUser, Condition} from '@legit.health/ui';
import {TFunction} from 'i18next';
import {AnamnesisQuestion} from '@/shared/interfaces/AnamnesisQuestion';
import {EncounterId} from '@/shared/interfaces/Encounter';
import AnamnesisStep from '../../../../steps/AnamnesisStep';
import {ConditionInfo, CreateDiagnosticReportResponse} from '../../../../types';
import anamnesisSessionStorage from '../../../../utils/anamnesisSessionStorage';
import InstructionsStep from '../Instructions';
import AlopeciaForm from './AlopeciaForm';

export default function Alopecia({
  conditionInfo,
  isForClinicalTrials,
  condition,
  anamnesisQuestions,
  visitIdentifier,
  setCurrentStep,
  onSuccess,
  patient,
  steps,
  currentStep,
  t
}: {
  anamnesisQuestions: AnamnesisQuestion[];
  conditionId: string;
  condition: Condition;
  conditionInfo: ConditionInfo | null;
  currentStep: number;
  extraPostData?: (conditionId: string | null) => Record<string, any>;
  isForClinicalTrials: boolean;
  onSuccess: (values: CreateDiagnosticReportResponse) => void;
  patient: BaseUser;
  setCurrentStep: Dispatch<SetStateAction<number>>;
  steps: {label: string; icon: ReactNode}[];
  t: TFunction;
  visitIdentifier: string;
  withTemporaryImages: boolean;
}) {
  const stepNumberModifier = isForClinicalTrials ? 1 : 0;
  const [form, setForm] = useState(() => ({
    anamnesisQuestions:
      anamnesisSessionStorage.get() ??
      anamnesisQuestions.reduce(
        (acc, aq) => ({
          ...acc,
          [aq.id]: ''
        }),
        {}
      )
  }));

  function handleSuccess(encounterId: EncounterId) {
    onSuccess({encounterId: encounterId, conditionId: `${condition.id}`, type: 'encounter'});
  }

  let node = null;

  if (currentStep === 1 - stepNumberModifier) {
    node = (
      <AnamnesisStep
        anamnesisQuestions={anamnesisQuestions}
        value={form.anamnesisQuestions}
        onBack={() => setCurrentStep((s) => s - 1)}
        onNext={function (value) {
          setForm((f) => ({...f, anamnesisQuestions: value}));
          setCurrentStep((s) => s + 1);
        }}
        t={t}
        activeStep={1}
        totalSteps={steps.length}
      />
    );
  } else if (currentStep === 2 - stepNumberModifier) {
    node = (
      <InstructionsStep
        onBack={() => setCurrentStep((s) => s - 1)}
        onNext={() => setCurrentStep((s) => s + 1)}
        t={t}
        activeStep={2 - stepNumberModifier}
        totalSteps={steps.length}
        condition={condition}
        conditionInfo={conditionInfo}
      />
    );
  } else if (currentStep === 3 - stepNumberModifier) {
    node = (
      <AlopeciaForm
        patientId={patient.id}
        condition={condition}
        setCurrentStep={setCurrentStep}
        steps={steps}
        t={t}
        onSuccess={handleSuccess}
        anamnesisAnswers={form.anamnesisQuestions}
        visitIdentifier={visitIdentifier}
      />
    );
  }
  return <div>{node}</div>;
}
